import styled from "styled-components";

export const ContentWrapper = styled.div`
  width: 80%;
  margin: 0 auto;
  dis & > * + * {
    margin-top: 24px;
  }
`;

export const LoaderWrapper = styled.div`
  text-align: center;
  transform: translate(0px, 200px);
`;

export const BadgeWrapper = styled.div`
  transform: translate(-33px,-28px);
  float: right;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;



// WEBPACK FOOTER //
// ./src/views/EventCampaign/style.js